import { Checkbox, FormControlLabel, FormHelperText, Switch, SxProps, Theme } from '@mui/material';
import { Controller, FieldValues, UseFormReturn } from 'react-hook-form';
import { FieldPath } from 'react-hook-form/dist/types/path/eager';
import { sentenceCase } from 'utils/casing';
import { PropertyOfType } from 'utils/typings';

interface FormTextFieldProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  name: FieldPath<T> & PropertyOfType<T, boolean>;
  helperText?: string;
  label?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}

// eslint-disable-next-line @typescript-eslint/ban-types
export const FormCheckbox = <T extends {}>({
  form,
  name,
  label,
  disabled,
  sx,
}: FormTextFieldProps<T>) => {
  const labelToShow = label ?? sentenceCase(name);

  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field }) => (
        <FormControlLabel
          control={<Checkbox disabled={disabled} />}
          label={labelToShow}
          checked={!!field.value}
          disabled={disabled}
          sx={sx}
          {...field}
        />
      )}
    />
  );
};

export const FormSwitch = <T extends object>({
  form,
  name,
  helperText,
  label,
  disabled,
  sx,
}: FormTextFieldProps<T>) => {
  const labelToShow = label ?? sentenceCase(name);

  return (
    <Controller
      name={name}
      control={form.control}
      render={({ field }) => (
        <>
          <FormControlLabel
            control={<Switch disabled={disabled} />}
            label={labelToShow}
            checked={!!field.value}
            disabled={disabled}
            sx={sx}
            {...field}
          />
          {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </>
      )}
    />
  );
};
